module.exports = __webpack_public_path__ + "img/orange_029.df75a762.png";